import { CLIENT } from 'constants';

// ------------------------------------
// Reducer
// ------------------------------------

export default function modalReducer(state = {}, action) {
  return action.type === CLIENT.SUCCESS ? action.payload : state;
}
